var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.popups.length)?_c('div',{staticClass:"popups"},_vm._l((_vm.popups),function(popup){return _c('popup-item',_vm._b({key:popup.id},'popup-item',popup,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }